module.exports = __webpack_public_path__ + "01ea978f/img/arrow-left-icon.785c715c.svg";